/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';
import {AbstractService, BLOB, BODY} from './abstract.service';

@Injectable()
export class PrintService {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get baseUrl(): string {
    return `${environment.api.url}${this.locale}/`;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                GET                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public printRemovalInvoice(ids: number[], qp?: QueryParams): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}removal/print-invoices?${AbstractService.urlEncodeArray('ids', ids)}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: BODY,
      reportProgress: false,
      responseType: BLOB
    });
  }

  public printAnimalVoucher(ids: number[], qp?: QueryParams): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}animal/print-vouchers?${AbstractService.urlEncodeArray('ids', ids)}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: BODY,
      reportProgress: false,
      responseType: BLOB
    });
  }

  public printAnimalFiles(id: number, qp?: QueryParams): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}animal/${id}/print-voucher`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: BODY,
      reportProgress: false,
      responseType: BLOB
    });
  }

  public printThirdPartyHistory(thirdPartyId: number, dateStart: string, dateEnd: string, qp?: QueryParams): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}third-party/${thirdPartyId}/print-history?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: BODY,
      reportProgress: false,
      responseType: BLOB
    });
  }

}
